import { useState } from 'react'
import { useIntl } from '@/intl'

export const useTexts = () => {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    timezone: translate({ id: 'settings.gpsAccount.edit.fields.timezone.label' }),
  }))

  return api
}
